import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SimpleAdmin, { DefaultOptions } from 'components/simpleAdmin';
import { apiPatch } from 'services';
import { setShowSuccess } from 'actions/ui';
import { load } from 'actions/admin';
import { DebugInfo, Picker, SystemText } from 'e4shared';
import TableListHover from 'components/admin/tableListHover';

export const AdminCollections = () => {
    const dispatch = useDispatch();

    const admin = useSelector(state => state.user.user?.sys_Config);
    if (!admin) {
        history.replace('/');
    }

    const user = useSelector(state => state.user.user);
    const loading = useSelector(state => state.admin.loading);

    const data = useSelector(state => state.admin.collectionWithLicenseInformation);
    const [pickerItem, setPickerItem] = useState();
    const [showPicker, setShowPicker] = useState(false);

    const allProfileGroups = useSelector(state => state.admin.profileGroups);

    const translations = {
        fields: {
            displayName: {
                label: SystemText('Admin/Quota/Fields/DisplayName/Label'),
                help: SystemText('Admin/Quota/Fields/DisplayName/Help'),
            },
        },
        table: {
            title: SystemText('Admin/Collection/Table/Title'),
            collectionName: SystemText('Admin/Collection/Table/CollectionName'),
            profileGroupAssigned: SystemText('Admin/Collection/Table/UserGroupsAssigned'),
            licenseInformation: SystemText('Admin/Collection/Table/LicenseInformation'),
            manageAccess: SystemText('Admin/Collection/Table/Options/ManageAccess'),
        },
        picker: {
            label: x => SystemText('Admin/Collection/Picker/Label', x),
            entity: SystemText('Admin/Collection/Picker/Entity'),
        },
    };

    const onLoad = () => {
        dispatch(load('profilegroups'));
        dispatch(load('collections-with-license-information'));
    };

    React.useEffect(() => {
        user?.guid && onLoad();
        DebugInfo('component', 'AdminCollections');
    }, []);

    const onUpdate = (entity, callback) => {
        const updateCollectionUserGroupsDto = {
            collectionId: entity.id,
            profileGroupIds: entity.profileGroup_ids,
        };

        apiPatch(
            'collections-user-groups',
            updateCollectionUserGroupsDto,
            user.guid,
            response => {
                data.forEach(d => {
                    if (d.id === entity.id) {
                        d.profileGroupsAssigned = response.profileGroupsAssigned;
                        d.licenseInformation = response.licenseInformation;
                    }
                });
                callback?.();
            },
            null,
            'PATCH',
            'json'
        );
    };

    const options = {
        ...DefaultOptions(),
        showDelete: false,
        label: translations.table.title,
        extraOptions: [
            {
                btnClass: 'btn-primary',
                label: () => translations.table.manageAccess,
                onClick: item => {
                    setPickerItem(item);
                    setShowPicker(true);
                },
            },
        ],
    };

    const tableColumns = [
        { label: translations.table.collectionName, dataProperty: 'name' },
        {
            label: translations.table.profileGroupAssigned,
            dataProperty: 'profileGroupsAssigned',
            className: 'no-wrap',
            format: (x, d) => (
                <TableListHover data={d?.profileGroupsAssigned?.map(g => g.name)} uniqueKey={`group-${d.id}`} />
            ),
            doNotSearch: true,
        },
        {
            label: translations.table.licenseInformation,
            dataProperty: 'licenseInformation',
            help: 'Total | Used | Remaining',
            doNotSearch: true,
        },
    ];

    return (
        <div data-testid="admin-collections-wrapper-testid">
            <SimpleAdmin
                data={data}
                loading={loading}
                fields={[]}
                options={options}
                columns={tableColumns}
                blockAddNew={true}
            />
            <Picker
                title={translations.picker.label(pickerItem?.name)}
                entity={translations.picker.entity}
                data={allProfileGroups}
                value={pickerItem?.profileGroupsAssigned.map(x => x.id)}
                show={showPicker}
                onSave={ids => {
                    onUpdate({ ...pickerItem, profileGroup_ids: ids }, () => {
                        setPickerItem(null);
                        setShowPicker(false);
                    });
                }}
                onClose={() => {
                    setPickerItem(null);
                    setShowPicker(false);
                    dispatch(setShowSuccess(false));
                }}
                itemPrefix="street-view"
            />
        </div>
    );
};

export default AdminCollections;
